var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.055 6.94 5.225.29a1 1 0 0 0-1.43 0 1 1 0 0 0 0 1.415L10.27 8l-6.475 6.295a1 1 0 0 0 0 1.41 1 1 0 0 0 1.43 0l6.83-6.645a1.5 1.5 0 0 0 0-2.12Z"
  })));
};
export default SvgChevronRight;